module.exports = __webpack_public_path__ + "images/c5d6bbd3a2bee573a9900128b4e44efa.png";